import { PlatformAdmin } from "../platform-admin-component/PlatformAdmin.jsx";

function PlatformAdminPage() {
  return <PlatformAdmin />;
}

export { PlatformAdminPage };
